"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("antd/dist/antd.css");

require("./StepsComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var steps = function steps(_ref) {
  var options = _ref.options,
      current = _ref.current,
      direction = _ref.direction,
      initial = _ref.initial,
      labelPlacement = _ref.labelPlacement,
      percent = _ref.percent,
      progressDot = _ref.progressDot,
      responsive = _ref.responsive,
      size = _ref.size,
      statusVal = _ref.statusVal,
      type = _ref.type,
      onChange = _ref.onChange,
      className = _ref.className,
      toEnableOnClick = _ref.toEnableOnClick,
      stepClsName = _ref.stepClsName;
  var Step = _antd.Steps.Step;
  return /*#__PURE__*/_react["default"].createElement(_antd.Steps, {
    current: current,
    direction: direction || "horizontal",
    initial: initial || 0,
    labelPlacement: labelPlacement || "horizontal",
    percent: percent || "",
    progressDot: progressDot || false,
    responsive: responsive === false ? false : true,
    size: size || "default",
    status: statusVal || "",
    type: type || "",
    onChange: onChange,
    className: "".concat(className, " iiht-ant-steps")
  }, options.map(function (data, index) {
    return /*#__PURE__*/_react["default"].createElement(Step, _extends({
      key: index,
      title: data.title,
      disabled: data.disabled ? true : false,
      icon: data.icon || "",
      status: data.statusVal || "",
      subTitle: data.subTitle || ""
    }, toEnableOnClick && {
      onClick: function onClick() {
        return data === null || data === void 0 ? void 0 : data.onStepClickHander();
      }
    }, {
      className: toEnableOnClick ? stepClsName : ""
    }));
  }));
};

var _default = steps;
exports["default"] = _default;